import { storeChangeSubscriber } from 'gtz.web.lib.storeutils';

import { logger } from '../utils';
import store from './createStore';

export const { addSubscription, listSubcriptions } = storeChangeSubscriber(store, logger);
